// Base 7 diagnostic questions (12 questions across 5 spheres)
const base7 = [
    // ── I Sfera: Bendroji energija ir savimoka — 3 questions ──
    {
      id: 'q1',
      sphere: 'bendra',
      question: 'Kai gyvenime iškyla sudėtingas klausimas ar svarbus sprendimas:',
      choices: {
        a: 'Skiriu laiko tylai ir apmąstymui, įsiklausau į savo vidinį balsą ir pasitikiu giliu žinojimu.',
        b: 'Pernelyg ilgai analizuoju, viską perfiltruoju mintyse ir užstringu abejonėse, taip ir nepriimdamas sprendimo.',
        c: 'Apgalvoju situaciją, bet stengiuosi nepasiklysti mintyse ir apsisprendžiu per protingą laiką.',
      },
    },
    {
      id: 'q2',
      sphere: 'bendra',
      question: 'Kai aplinkui daug triukšmo, žmonių ir nuolatinio judėjimo:',
      choices: {
        a: 'Sąmoningai pasitraukiu į tylą ir vienatvę, nes ramybėje atrandu jėgų ir aiškumo.',
        b: 'Visiškai užsisklendžiu nuo pasaulio ir taip ilgai vengiu žmonių, kad pradedu jaustis vienišas.',
        c: 'Pailsiu vienumoje, kai pavargstu, bet sąmoningai grįžtu ir tarp žmonių.',
      },
    },
    {
      id: 'q3',
      sphere: 'bendra',
      question: 'Kai susiduriu su tuo, ko negaliu paaiškinti logika:',
      choices: {
        a: 'Atsiveriu paslapčiai ir intuicijai, nes tikiu, kad ne viskas turi būti įrodyta protu.',
        b: 'Viską skeptiškai atmetu arba bandau valdyti per nuolatinį abejojimą ir kritiką.',
        c: 'Domiuosi ir svarstau, bet išvadas darau tik radęs pakankamai pagrindo.',
      },
    },
    // ── II Sfera: Darbas ir karjera — 2 questions ──
    {
      id: 'q4',
      sphere: 'karjera',
      question: 'Kai darbe reikia gilios analizės ar ilgo susikaupimo:',
      choices: {
        a: 'Tai mano stiprybė – panyru į temą, įžvelgiu esmę ir randu sprendimus, kurių kiti nepastebi.',
        b: 'Taip įklimpstu į detales ir tobulumo siekį, kad prarandu laiką ir bijau parodyti rezultatą.',
        c: 'Įsigilinu, kiek reikia, bet stengiuosi nepasiklysti smulkmenose ir užbaigti darbą.',
      },
    },
    {
      id: 'q5',
      sphere: 'karjera',
      question: 'Kai tenka dirbti komandoje ar nuolat būti tarp žmonių:',
      choices: {
        a: 'Galiu prisidėti savo įžvalgomis, bet vertinu ir galimybę dirbti savarankiškai, savo ritmu.',
        b: 'Atsiriboju, vengiu bendravimo ir mieliau viską darau vienas, net kai pagalba praverstų.',
        c: 'Bendrauju, kiek būtina, bet sąmoningai pasilieku laiko ir tyliam, individualiam darbui.',
      },
    },
    // ── III Sfera: Santykiai ir partnerystė — 2 questions ──
    {
      id: 'q6',
      sphere: 'santykiai',
      question: 'Kai artimas žmogus nori su manimi pasidalinti jausmais ar priartėti:',
      choices: {
        a: 'Atsiveriu nuoširdžiai ir leidžiu būti pažintas, nes gilus ryšys man yra vertybė.',
        b: 'Užsisklendžiu, slepiu jausmus ir laikau žmones saugiu atstumu, nes bijau būti pažeidžiamas.',
        c: 'Atsiveriu palaipsniui, tik tada, kai jaučiuosi pakankamai saugus ir pasitikintis.',
      },
    },
    {
      id: 'q7',
      sphere: 'santykiai',
      question: 'Kai galvoju apie tai, ko ieškau artimame žmoguje:',
      choices: {
        a: 'Vertinu gilų dvasinį ir intelektualinį ryšį, nuoširdžius pokalbius ir abipusį supratimą.',
        b: 'Idealizuoju arba laikausi atstumo, nes baiminuosi, kad realus žmogus nuvils mano lūkesčius.',
        c: 'Ieškau žmogaus, su kuriuo derėtų ir gilumas, ir paprastas, kasdienis artumas.',
      },
    },
    // ── IV Sfera: Finansai ir resursai — 2 questions ──
    {
      id: 'q8',
      sphere: 'finansai',
      question: 'Kai tvarkau pinigus ir materialius reikalus:',
      choices: {
        a: 'Pasikliauju ir analize, ir intuicija, neleisdamas, kad pinigai taptų svarbiausiu mano gyvenimo tikslu.',
        b: 'Arba visai nuvertinu materialius dalykus, arba per daug dėl jų nerimauju ir vis svarstau.',
        c: 'Stengiuosi tvarkytis racionaliai, bet pripažįstu, kad finansai nėra mano stipriausia pusė.',
      },
    },
    {
      id: 'q9',
      sphere: 'finansai',
      question: 'Kai galvoju apie pinigų ir prasmės santykį:',
      choices: {
        a: 'Renkuosi veiklą, kuri turi gilesnę prasmę, ir tikiu, kad ji atneš ir pakankamai išteklių.',
        b: 'Jaučiuosi atitrūkęs nuo materialaus pasaulio arba laikau pinigus „žemišku" dalyku, vertu paniekos.',
        c: 'Ieškau pusiausvyros tarp prasmingos veiklos ir realaus finansinio saugumo.',
      },
    },
    // ── V Sfera: Savirealizacija ir gyvenimo situacija — 3 questions ──
    {
      id: 'q10',
      sphere: 'savirealizacija',
      question: 'Kai gyvenime jaučiu vidinę tuštumą ar prasmės stoką:',
      choices: {
        a: 'Sąmoningai gilinuosi į save, ieškau atsakymų knygose, tyloje ar dvasinėje praktikoje, ir tai mane pripildo.',
        b: 'Pasineriu į niūrias mintis ir izoliaciją, ilgam užstrigdamas savo galvoje be išeities.',
        c: 'Po truputį ieškau prasmės, bet stengiuosi neapsiriboti vien apmąstymais ir grįžti į gyvenimą.',
      },
    },
    {
      id: 'q11',
      sphere: 'savirealizacija',
      question: 'Kai galvoju apie savo gilesnį žinojimą ir intuiciją:',
      choices: {
        a: 'Pasitikiu savo vidiniu balsu ir leidžiu jam vesti mane net tada, kai protas negali paaiškinti.',
        b: 'Nuvertinu savo nuojautą, viską matuoju tik logika arba ja abejoju, kol prarandu ryšį su savimi.',
        c: 'Įsiklausau į intuiciją, bet ją dar derinu su logiškais argumentais, prieš ja sekdamas.',
      },
    },
    {
      id: 'q12',
      sphere: 'savirealizacija',
      question: 'Kai gyvenimas pateikia skausmingų išbandymų:',
      choices: {
        a: 'Priimu juos kaip gilesnio augimo pamoką ir ieškau jų prasmės savo kelyje.',
        b: 'Užsidarau savyje, atsiriboju nuo visų ir ilgai nešuosi skausmą vienas, niekam jo nepatikėdamas.',
        c: 'Išgyvenu sunkmetį tyloje, bet pamažu ieškau atsakymų ir vėl atsiveriu pasauliui.',
      },
    },
  ];

export default base7;
